import { RefreshCw, ShieldCheck } from "lucide-react";
import type { Notify } from "./admin-types";
import { Header } from "./AdminPagePrimitives";
import { adminOverviewMetrics } from "./admin-presentation";

import { useAdminOverviewWorkspace } from "./useAdminOverviewWorkspace";

export function OverviewPage({notify}: {notify: Notify}) {
  const { data, load } = useAdminOverviewWorkspace({notify});
  const metrics = adminOverviewMetrics(data);
  return (
    <>
      <Header
        eyebrow="Sistem yönetimi"
        title="Sistem Genel Bakış"
        description="Kimlik, erişim, oturum ve bildirim sağlığını tek ekrandan izleyin."
        action={
          <button className="secondary-button" onClick={load}>
            <RefreshCw size={15} /> Yenile
          </button>
        }
      />
      <section className="admin-metrics">
        {metrics.map(([label, value, detail]) => (
          <article key={label}>
            <small>{label}</small>
            <strong>{value}</strong>
            <span>{detail}</span>
          </article>
        ))}
      </section>
      <section className="admin-guidance">
        <ShieldCheck size={20} />
        <div>
          <strong>Yetkiler birleşir, görevler ayrışır</strong>
          <p>
            Bir kullanıcı birden fazla role sahip olabilir. Sistem yönetimi
            yetkisi operasyonel satın alma veya yönetici onayı yetkisini
            kendiliğinden vermez.
          </p>
        </div>
      </section>
    </>
  );
}
